<template>
    <transition name="fade">
        <div class="quiz-creator-loader flex justify-center items-center w-full h-full absolute">
            <div>
                <div></div>
                <div></div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {}
</script>

<style lang="scss">
.quiz-creator-loader {
    background-color: #fff;
    z-index: 1000;

    div {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;

        > div {
            position: absolute;
            border: 4px solid;
            opacity: 1;
            border-radius: 50%;
            animation: quiz-creator-loader 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
            color: #ef0000;
        }

        div:nth-child(2) {
            animation-delay: -0.5s;
            color: #ef0000;
        }
    }
}

@keyframes quiz-creator-loader {
    0% {
        top: 36px;
        left: 36px;
        width: 0;
        height: 0;
        opacity: 1;
    }

    100% {
        top: 0px;
        left: 0px;
        width: 72px;
        height: 72px;
        opacity: 0;
    }
}
</style>